'use strict';

"use strict";
class GpuRenderTarget {
  constructor() {
    this.contexts = [];
    this.msaaTextures = [];
    this.msaaSamples = 1;
  }
}

exports.GpuRenderTarget = GpuRenderTarget;
//# sourceMappingURL=GpuRenderTarget.js.map
